import type { UserMessage } from "@bt-common/schemas/bt/user-message";

/**
 * What a per-row delete ("X" button on a scheduled-message row) does once
 * the user confirms.
 *
 * whatsapp-scheduler#166 fix-wave / whatsapp-scheduler#149 (BUG-2): this is a
 * BEHAVIOUR-PRESERVING extraction of the decision whatsapp-message.tsx's
 * `handleDeleteConfirmed` already makes — it does NOT change what gets
 * deleted. In particular `recurring-scope-prompt` still resolves (in the
 * component) to `onDeleteRecurringDialogCloseThunk({ value: "All messages" })`
 * unconditionally, regardless of the row's status. A recurring row that is
 * `sent_pending_ack` (already handed to WhatsApp — the #166 population) is
 * therefore deleted as part of that whole-series delete, with a generic
 * confirmation dialog and no per-occurrence option. That is a real defect —
 * the same failure shape #149 was opened for — newly reachable because this
 * branch makes those rows visible in the sidebar for the first time. Fixing
 * the scoping is a product decision that belongs to #149, not this change;
 * see rowDeleteScope.test.ts, which documents (not "fixes") the current
 * behaviour.
 */
export type RowDeletePlan =
  | { kind: 'single' }
  | { kind: 'recurring-scope-prompt' };

export function planRowDelete(
  message: Pick<UserMessage, 'isRecurring' | 'rruleset'>,
): RowDeletePlan {
  if (message.isRecurring && message.rruleset) {
    return { kind: 'recurring-scope-prompt' };
  }
  return { kind: 'single' };
}
